"use client"

import Link from "next/link"
import { usePathname } from "next/navigation"
import { cn } from "@/lib/utils"
import { useTranslations } from "next-intl"

interface SidebarItem {
    title: string
    href: string
}

interface DocsSidebarProps {
    items: SidebarItem[]
    locale: string
}

export function DocsSidebar({ items, locale }: DocsSidebarProps) {
    const pathname = usePathname()
    const t = useTranslations('marketing.footer.legal')

    return (
        <aside className="hidden lg:block w-64 shrink-0 pr-8 rtl:pr-0 rtl:pl-8">
            <div className="sticky top-24 space-y-8">
                <div className="space-y-4">
                    <h3 className="font-semibold text-sm tracking-tight text-foreground">
                        {t('legalCenter')}
                    </h3>
                    <div className="w-full h-px bg-border/50" />
                    <nav className="flex flex-col gap-1">
                        {items.map((item) => {
                            const isActive = pathname === item.href
                            return (
                                <Link
                                    key={item.href}
                                    href={item.href}
                                    className={cn(
                                        "flex items-center justify-between py-1.5 px-2 text-sm transition-colors",
                                        isActive
                                            ? "font-medium text-primary bg-primary/5 rounded-md"
                                            : "text-muted-foreground hover:text-foreground hover:bg-muted/50 rounded-md"
                                    )}
                                >
                                    <span>{item.title}</span>
                                </Link>
                            )
                        })}
                    </nav>
                </div>
            </div>
        </aside>
    )
}
